
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-37546dc6\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../vue-loader/lib/selector?type=styles&index=0!./Circle.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./Circle.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-37546dc6\"}!../../../vue-loader/lib/selector?type=template&index=0!./Circle.vue"),
  /* scopeId */
  "data-v-37546dc6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loading-spinner/src/components/Circle.vue
// module id = 545
// module chunks = 0